class Translator {
  text: { [key: string]: {} } = {
    nl: {
      airlearn: 'Airlearn',
      navBar: {
        content: 'Lesmateriaal',
        search: 'Zoeken...',
        learnHome: 'Mijn Leeromgeving'
      },
      search: {
        searchResults: 'Zoekresultaten',
        noResults: 'Er zijn geen zoekresultaten gevonden',
        loading: 'Laden...'
      },
      overview: {
        chapter: 'Hoofdstukken',
        paragraph: 'Paragrafen',
        noContent: 'Geen content gevonden. Probeer je filters aan te passen.',
        types: {
          '': 'Overig',
          SAMENVATTING: 'Samenvatting',
          UITWERKINGEN: 'Uitwerkingen',
          OEFENING: 'Oefening',
          'UITLEG ANDERS': 'Uitleg',
          OEFENINGEN: 'Oefeningen'
        }
      },
      contentView: {
        suggest: 'Suggestie maken'
      },
      suggestion: {
        header: 'Nieuwe content suggereren',
        link: 'Link',
        description: 'Omschrijving',
        suggestionSent: 'Suggestie verstuurd. We gaan er naar kijken, bedankt!',
        suggestAgain: 'Nog een suggestie maken'
      },
      home: {
        adv1: 'Op maat',
        adv2: 'Beste kwaliteit',
        adv3: 'Snel',
        about: 'About Airlearn',
        aboutPromo: 'Een platform met alles wat jij nodig hebt voor school, online!',
        loremIpsum: 'mod tempor incidunt ut labore et dolore magna aliqua enim ad minim veniam, quis nostrud. Odi et amo, quare id faciam.',
        registerNow: 'meld je nu aan!',
        welcomeText: 'Welkom bij Airlearn. Hier kun je leren wanneer en waar je nodig hebt.',
        welcomeSubText: 'Geef je klas en vakken door. Vervolgens krijg je een verzameling van video\'s, uitleg en opdrachten die precies aansluiten op waar jij bent in het vak. Je kunt er op elk moment van de dag bij!',
        registerText: 'Maak een account aan voor gepersonaliseerd lesmateriaal',
        letsGo: 'Aan de slag',
        expect: 'Wat kun je verwachten',
        promoText1: 'Leer waar en wanneer je het nodig hebt.',
        promoText2: 'Geef je klas en vakken door. Vervolgens krijg je een verzameling van video\'s, uitleg en opdrachten die precies aansluiten op waar jij bent in het vak. Je kunt er op elk moment van de dag bij',
        promoText3: 'Op jou afgestemd.',
        promoText4: 'Met jouw profiel krijg je precies te zien wat relevant voor je is.',
        makeProfile: 'Maak profiel'
      },
      settings: {
        settings: 'Instellingen'
      },
      filterMenu: {
        filters: 'Filters',
        format: 'Formaat',
        type: 'Type'
      },
      learnHome: {
        grade: 'Klas',
        header: 'Leeromgeving van #',
        selectBook: 'Selecteer je boek',
        yourCourses: 'Jouw vakken',
        yourFavorites: 'Jouw favorieten',
        recommendedContent: 'Aanbevelingen',
        changeGrade: {
          title: 'Klas aanpassen',
          title2: 'Vakken aanpassen',
          page1text: 'Selecteer je nieuwe klas',
          page2text: 'Selecteer je nieuwe vakken'
        }
      },
      register: {
        header: 'Welkom # voor de eerste keer!',
        page1Text: 'We geven je graag persoonlijk het beste lesmateriaal. Omdat je net nieuw bent leren we je graag even kennen. Selecteer hieronder je klas en de vakken die je doet.',
        page1Text2: 'In welke klas zit je?',
        page2Text2: 'Welke vakken volg je?',
        page3Text: 'Vul een wachtwoord in om je aanmelding af te ronden.',
        page4Text: 'Er is een e-mail verstuurd naar # met een verificatielink. Klik op de link in de e-mail om je registratie te voltooien.'
      },
      verify: {
        verified: 'E-mail account geverifiëerd. Klik op de knop om in te loggen.',
        verifying: 'E-mail aan het verifiëren...',
        error: 'Er is iets fout gegaan. Probeer het later opnieuw.',
        verifyEmail: 'E-mail verifiëren'
      },
      cinema: {
        favorite: 'Favoriet',
        teacher: 'Leraar',
        remarks: 'Opmerkingen',
        rate: 'Reviews',
        review: 'Review',
        selectRating: 'Kies een rating',
        description: 'Omschrijving'
      },
      filters: {
        favorites: 'Alleen favorieten'
      },
      forms: {
        select: 'Selecteren',
        search: 'Zoektermen',
        add: 'Aanmaken',
        append: 'Toevoegen',
        letsGo: 'Aan de slag!',
        save: 'Opslaan',
        previous: 'Vorige',
        next: 'Volgende',
        page: 'Pagina',
        return: 'Terug',
        name: 'Naam',
        email: 'Email',
        emailExists: 'Email adres bestaat al',
        password: 'Wachtwoord',
        passwordRepeat: 'Herhaal wachtwoord',
        send: 'Versturen',
        close: 'Sluiten'
      },
      notfound: {
        notfound: 'Pagina niet gevonden'
      },
      login: {
        login: 'Inloggen',
        logout: 'Uitloggen',
        forgotSent: 'Er is een e-mail verstuurd naar # met instructies om een nieuw wachtwoord aan te vragen.',
        forgotPassword: 'Wachtwoord vergeten?',
        requestNew: 'Nieuw wachtwoord aanvragen',
        wrongLogin: 'Combinatie email/wachtwoord niet geldig'
      },
      resetPassword: {
        title: 'Vul je nieuwe wachtwoord in',
        changed: 'Je wachtwoord is veranderd. Druk op de knop om in te loggen.'
      }
    }
  }

  public getText (lang: string) {
    return this.text[lang]
  }
}

const translator = new Translator().getText('nl')
export default translator
